import { render, staticRenderFns } from "./AddRevenue.vue?vue&type=template&id=5185ab2d&scoped=true&"
import script from "./AddRevenue.vue?vue&type=script&lang=js&"
export * from "./AddRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5185ab2d",
  null
  
)

export default component.exports